/* global process */
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query";
import { getAuthApiBaseUrl } from "./authApiBase";

export interface SdaUser {
  email: string;
  name: string;
  roles: string[];
  isUbuildAdmin: boolean;
  acknowledgedAt: string | null;
}

export interface SdaSession {
  idToken: string;
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
  user: SdaUser;
}

export interface SdaRefreshResult {
  idToken: string;
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
}

export const SSOAuthApi = createApi({
  reducerPath: "ssoAuth",
  baseQuery: fetchBaseQuery({
    baseUrl: `${getAuthApiBaseUrl()}/`,
  }),
  endpoints: (builder) => ({
    exchangeCode: builder.mutation<SdaSession, { code: string; state: string }>({
      query: ({ code, state }) => ({
        url: "callback",
        method: "POST",
        body: { code, state },
      }),
    }),
    refresh: builder.mutation<SdaRefreshResult, string>({
      query: (refreshToken) => ({
        url: "refresh",
        method: "POST",
        body: { refreshToken },
      }),
    }),
    validate: builder.mutation<{ valid: boolean }, string>({
      query: (token) => ({
        url: "validate-token",
        method: "POST",
        body: { token },
      }),
    }),
    logout: builder.mutation<{ endSessionUrl: string }, { idToken: string; postLogoutRedirectUri: string }>({
      query: ({ idToken, postLogoutRedirectUri }) => ({
        url: "logout",
        method: "POST",
        body: { idToken, postLogoutRedirectUri },
      }),
    }),
  }),
});
